import { render, staticRenderFns } from "./ImmediateMessagePopup.vue?vue&type=template&id=25d81fd7&scoped=true"
import script from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
export * from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
import style0 from "./ImmediateMessagePopup.vue?vue&type=style&index=0&id=25d81fd7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d81fd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d81fd7')) {
      api.createRecord('25d81fd7', component.options)
    } else {
      api.reload('25d81fd7', component.options)
    }
    module.hot.accept("./ImmediateMessagePopup.vue?vue&type=template&id=25d81fd7&scoped=true", function () {
      api.rerender('25d81fd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/messages/ImmediateMessagePopup.vue"
export default component.exports